<template>
  <div class="card mt-3">
      <div class="card-content">
            <slot />
      </div>
  </div>
</template>

<script>
export default {
    name: 'Card',
}
</script>